export default {"src":"/_next/static/media/folder-folder.692c40f0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};